const communityApi = {
  GETALLCONTENT: '/community/getAllContent', //获取社区数据
  OPERATION: '/community/batchUpdate', //批量审核通过拒绝社区
  ADDDYNAMIC: '/community/addContent', //批量审核通过拒绝社区
  DELECTDYNAMIC: '/community/deleteContentById', //批量审核通过拒绝社区
  EDITDYNAMIC: '/community/getOneRecord', //根据编辑按钮编辑数据
  UPDATEDYNAMIC: '/community/updateContent' //编辑管理数据
}

export default communityApi
